import styled from 'styled-components'

export const EditCourseRetroactiveAlertSection = styled.div`
  width: 100%;
  margin-top: 16px;
`
